import React, { useState } from 'react';

import { useAnchor } from 'shared/mui/DatePicker/hooks/useAnchor';
import { FilterFavoriteButton } from 'shared/mui/Filter/FilterButtons/FilterFavoriteButton/FilterFavoriteButton';
import { FilterFavoritePopover } from 'shared/mui/Filter/FilterFavoritePopover/FilterFavoritePopover';
import { useFavoriteFilters } from 'shared/mui/Filter/FilterSaveFavorite/hooks/useFavoriteFilters';

export type FilterFavoriteProps = {
  dateFields?: string[];
};

export const FilterFavorite: React.FC<FilterFavoriteProps> = ({ dateFields }) => {
  const { handleClose, handleClick, anchorEl } = useAnchor<HTMLButtonElement>();
  const { favorites } = useFavoriteFilters();
  const [name, setName] = useState<string | undefined>(undefined);

  const open = Boolean(anchorEl);
  const id = open ? 'filter-favorite' : undefined;

  return (
    <>
      {!!favorites.length && (
        <FilterFavoriteButton
          onClick={(e) => {
            handleClick(e);
          }}
        />
      )}
      {!!favorites.length && (
        <FilterFavoritePopover
          anchorEl={anchorEl}
          dateFields={dateFields}
          id={id}
          name={name}
          onClose={handleClose}
          open={open}
          setName={setName}
        />
      )}
    </>
  );
};
